const setModalAtiva = (context, payload) => {
  context.commit('MODAL_ATIVA', payload)
}

const setSetorAtivo = (context, payload) => {
  context.commit('MUDAR_SETOR_ATIVO', payload)
}

const toggleMenu = (context, payload) => {
  context.commit('TOGGLE_MENU', payload)
}

const enviarInformacaoModal = (context, payload) => {
    context.commit('ENVIAR_INFORMACOES_MODAL', payload)
}

const enviarInformacaoModalBrasil = (context, payload) => {
    context.commit('ENVIAR_INFORMACOES_MODAL_BRASIL', payload)
}

const mostrarModalVideo = (context, payload) => {
    console.log(payload)
    context.commit('MOSTRAR_VIDEO', payload)
  }



export default {
  setModalAtiva,
  setSetorAtivo,
  toggleMenu,
  enviarInformacaoModal,
  enviarInformacaoModalBrasil,
  mostrarModalVideo
}
